module.exports = __webpack_public_path__ + "media/images/justice-14efa072b5238f2a76ef3f518608ae6a.svg";